import {combineReducers} from 'redux'
import createICalFeedsReducer from './reducer'
import createICalLightBoxReducer from './components/lightbox/reducer'

export default (initAppData) => combineReducers({
    feeds: createICalFeedsReducer(initAppData),
    configuredFeed: createICalLightBoxReducer(initAppData),
})



// WEBPACK FOOTER //
// ./web/actiplans/js/icalendar/iCalReducer.js